import React, { useEffect, useState } from "react";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import PincodeInput from "../../../../widget/common/ui/PincodeInput";
import { SettingsAccountVerificationContextImport } from "../../../../provider/settings/security/account_verification/SettingsAccountVerificationContextProvider";
import StorageKeys from "../../../../const/StorageKeys";
import SessionStorage from "../../../../service/storage/SessionStorage";
import { Col } from "react-bootstrap";
import Countdown from "../../../../widget/common/ui/Coundown";

const SettingsAccountVericationContent = (props: { type: number }) => {
  const type = props.type;

  const { sendPin, pincodeLength, updateCountDownStatus } =
    SettingsAccountVerificationContextImport();

  const [code, setCode] = useState<string>("");
  const [pinReset, setPinReset] = useState<boolean>(false);

  const [verificationType, setVerificationType] = useState<"email" | "phone">(
    "email"
  );
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const checkVericationTypeSession = () => {
    const verificationTypeSession: string = SessionStorage.getValue(
      StorageKeys.settings_verification_type
    );

    setVerificationType(verificationTypeSession as "email" | "phone");

    if (verificationTypeSession === "phone") {
      const verificationPhoneSession: any = SessionStorage.getValue(
        StorageKeys.settings_verification_change_phone_value
      );
      const verificationPhoneDetail: {
        phone_code: string;
        phone_code_id: string;
        phone_number: string;
      } = JSON.parse(verificationPhoneSession);

      setPhone(
        `${verificationPhoneDetail.phone_code}${verificationPhoneDetail.phone_number}`
      );
    } else {
      const verificationEmailSession: string = SessionStorage.getValue(
        StorageKeys.settings_verification_change_email_value
      );

      setEmail(verificationEmailSession);
    }
  };

  const completedTimer = () => {
    updateCountDownStatus(false);
    setPinReset(true);

    setInterval(() => {
      setPinReset(false);
    }, 500);
  };

  useEffect(() => {
    sendPin(code);
    // eslint-disable-next-line
  }, [code]);

  useEffect(() => {
    checkVericationTypeSession();
  }, []);

  return (
    <Div className="pt-5 d-center text-center">
      <Col xs={12} lg={6}>
        <Center>
          <TextBlock
            fontName="book"
            fontSize="16_17"
            textColor="theme-sublabel"
          >
            {verificationType === "phone" ? (
              <>
                {AppTranslation.text("please_enter_mobile_number")} {phone}
              </>
            ) : (
              <>
                {AppTranslation.text("please_enter_email_address")} {email}
              </>
            )}
          </TextBlock>
        </Center>
        <SpacingHeight value={type === 1 ? 40 : type === 2 ? 50 : 73} />
        <PincodeInput
          length={pincodeLength}
          onChange={setCode}
          resetStatus={pinReset}
        />
        <SpacingHeight value={13} />
        <TextBlock fontName="book" fontSize="16_17" textColor="theme-sublabel">
          <Countdown
            duration={5 * 60} // 2 minutes = 120 seconds
            onComplete={() => completedTimer()}
          />
        </TextBlock>
        <SpacingHeight value={50} />
      </Col>
    </Div>
  );
};

export default SettingsAccountVericationContent;
